var logForGoogleAnalytics = function logForGoogleAnalytics(gtmData) {
  window.gtmDataLayer = window.gtmDataLayer || [];
  window.gtmDataLayer.push(gtmData);
};
export default logForGoogleAnalytics;